import { FlatAppbar } from 'ui/FlatAppbar';

export const PayHeader = FlatAppbar;
